module.exports = __webpack_public_path__ + "img/qr-tracking-stop.59949d74.svg";